import { SpeechEngineVersions } from 'src/app/core/constants';

export const TTS_VARIANT_SKIDBLADNIR = 'skidbladnir';

let resolved: SpeechEngineVersions | null = null;

export const setSpeechEngine = (v: SpeechEngineVersions | null) => { resolved = v; };

export const currentSpeechEngine = (): SpeechEngineVersions =>
  resolved ?? SpeechEngineVersions.Nephilim;

// export const speechEngineFromTtsVariant = (variant: string | null | undefined): SpeechEngineVersions | null =>
//   variant === TTS_VARIANT_SKIDBLADNIR ? SpeechEngineVersions.Skidbladnir : null;

// Temporary workaround for the speech engine issue. This will be removed once the Canary deployment for Skidbladnir API is deployed.
export const speechEngineFromTtsVariant = (variant: string | null | undefined): SpeechEngineVersions | null =>
{
  console.log('speechEngineFromTtsVariant', variant);
  return SpeechEngineVersions.Skidbladnir;
}